const m = require('minthril/lib/hyperscript');
const createRender = require('minthril/lib/render');
const { Pages } = require('./pages');

function isApplicationPath(pathname) {
  return !/\/[^/]+\.[a-z0-9]{1,12}$/i.test(pathname);
}

function scrollBodyToTop() {
  window.scrollTo(0, 0);
}

function handleAnchorClick(event, appRoot) {
  if (event.defaultPrevented || event.button !== 0) {
    return;
  }

  if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) {
    return;
  }

  const anchor = event.target instanceof Element
    ? event.target.closest('a[href]')
    : null;
  if (!anchor || anchor.target || anchor.hasAttribute('download')) {
    return;
  }

  const destination = new URL(anchor.href, window.location.href);
  if (destination.origin !== window.location.origin) {
    return;
  }

  if (!isApplicationPath(destination.pathname)) {
    return;
  }

  event.preventDefault();
  window.history.pushState({}, '', `${destination.pathname}${destination.search}${destination.hash}`);
  scrollBodyToTop();
  appRoot.dispatchEvent(new Event('redraw'));
}

function renderApp(appRoot) {
  const render = createRender(appRoot.ownerDocument.defaultView);
  let pendingRedraw;

  function redraw() {
    if (pendingRedraw) {
      return pendingRedraw;
    }

    pendingRedraw = Promise.resolve().then(() => {
      render(appRoot, m(Pages));
      pendingRedraw = null;
    });

    return pendingRedraw;
  }

  appRoot.addEventListener('redraw', redraw);
  appRoot.addEventListener('click', event => handleAnchorClick(event, appRoot));
  window.addEventListener('popstate', () => {
    scrollBodyToTop();
    appRoot.dispatchEvent(new Event('redraw'));
  });

  redraw();
}

if (!require.main) {
  window.addEventListener('DOMContentLoaded', () => {
    renderApp(window.document.body);
  });
}

module.exports = { handleAnchorClick, isApplicationPath, renderApp };
